import { isSpider } from '@/common/utils/index';
export const actions = {
  async nuxtServerInit({ dispatch, commit }, { req, app, query, route }) {
    const ua = req.headers['user-agent'] || '';
    let [{ defaultMode } = {} ] = route.meta;

    let { renderMode = defaultMode || 'ssr' } = query;
    // 爬虫agent均采用ssr
    if (isSpider(ua)) {
      renderMode = 'ssr';
    }

    commit('common/setRenderData', { mode: renderMode });

    if (renderMode === 'ssr') {
      await dispatch('common/getCommonData', { app });
    } else {
      commit('common/setRenderData', { loading: true });
    }
  },
};
